/**
 * HTTP error with status code.
 *
 * `body` exposes the parsed JSON response body (when the response was JSON)
 * so callers can branch on structured error payloads — e.g. a 409's
 * `data.assignedTenants` list — instead of only the flattened `message`.
 * It is `undefined` for non-JSON / empty responses.
 */
export class HttpError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    public readonly body?: unknown
  ) {
    super(message)
    this.name = 'HttpError'
    Object.setPrototypeOf(this, HttpError.prototype)
  }
}
